import { forEach, isEmpty } from 'lodash';
import i18next from 'i18next';

export const copyCodeButtonLabel = (buttonText) => (
  buttonText || i18next.t('ws_templates.defaults.copy_code_button')
);

export const isAuthenticationTemplate = (wsTemplate = {}) => (
  String(wsTemplate.category || '').toUpperCase() === 'AUTHENTICATION'
  || wsTemplate.interactive_action === 'copy_code'
  || wsTemplate.interactive_action === 3
);

const handleReplace = (inputText, isExample) => {
  if (isExample || /\{\{1\}\}/.test(inputText)) {
    return inputText;
  }
  const regex = /(?<!\\)(?<!\\\\)\*/g;
  const matches = inputText && inputText.match(regex);
  let sequence = 1;
  return matches ? inputText.replace(regex, () => `{{${sequence++}}}`) : inputText;
};

export const generateFormattedText = (wsTemplate, isExample = false) => {
  let inputText = '';
  if (wsTemplate.header_text) {
    inputText += `${wsTemplate.header_text}\n`;
  }
  inputText += wsTemplate.text || '';

  const interactiveAction = wsTemplate.interactive_action;
  const isNotApply = interactiveAction === 'not_apply' || 
                     interactiveAction === 'none' || 
                     interactiveAction === 0;

  if (isNotApply && !isAuthenticationTemplate(wsTemplate)) {
    return handleReplace(inputText, isExample).replaceAll('\\*', '*');
  }

  const existingButtons = inputText
    .split('| ')
    .slice(1)
    .map((buttonPart) => buttonPart.trim());

  // Handle buttons in different formats
  let buttonsArray = [];
  if (Array.isArray(wsTemplate.buttons)) {
    buttonsArray = wsTemplate.buttons;
  } else if (wsTemplate.buttons && typeof wsTemplate.buttons === 'object') {
    if (wsTemplate.buttons.type) {
      buttonsArray = [wsTemplate.buttons];
    } else {
      buttonsArray = Object.values(wsTemplate.buttons);
    }
  }

  const isQuickReplyAction = interactiveAction === 'quick_reply'
    || interactiveAction === 2;
  const isCopyCodeAction = isAuthenticationTemplate(wsTemplate);
  let addedAuthButton = false;

  forEach(buttonsArray, (cta) => {
    let buttonText = '';
    let urlToUse;
    const otpButtonLabel = copyCodeButtonLabel(cta.text);

    switch (cta.type) {
      case 'PHONE_NUMBER':
        buttonText = `[${cta.text},${cta.phone_number}]`;
        break;
      case 'URL':
        urlToUse = isExample && cta.example && !isEmpty(cta.example) ? cta.example : cta.url;
        buttonText = `[${cta.text},${urlToUse}]`;
        break;
      case 'QUICK_REPLY':
        buttonText = `[${cta.text}]`;
        break;
      case 'OTP':
        buttonText = `[${otpButtonLabel}]`;
        addedAuthButton = true;
        break;
      default:
        if (isQuickReplyAction) {
          buttonText = `[${cta.text}]`;
        } else if (isCopyCodeAction) {
          buttonText = `[${otpButtonLabel}]`;
          addedAuthButton = true;
        }
        break;
    }

    const buttonAlreadyExists = existingButtons.some((existingButton) => {
      if (cta.type === 'QUICK_REPLY') {
        return existingButton === `[${cta.text}]`;
      }
      if (cta.type === 'OTP' || isCopyCodeAction) {
        return existingButton === `[${otpButtonLabel}]`;
      }
      return existingButton.includes(cta.text);
    });

    if (buttonText && !buttonAlreadyExists) {
      inputText = `${inputText} | ${buttonText}`;
    }
  });

  if (isCopyCodeAction && !addedAuthButton) {
    inputText = `${inputText} | [${copyCodeButtonLabel()}]`;
  }

  return handleReplace(inputText, isExample).replaceAll('\\*', '*');
};
